export default __webpack_public_path__ + "static/media/Group -5.047cb1ee.png";